// extracted by mini-css-extract-plugin
module.exports = {"container":"forgot_container__2K0aN","form":"forgot_form__33iCz"};